import React, { useCallback } from 'react';
import {
  RemoveEmployeeSkillDialog,
  Props as RemoveEmployeeSkillDialogProps,
} from '../../../Skills/dialog/RemoveEmployeeSkillDialog';
import { useRemoveProjectSkill } from './useProjectSkillsMutations';

type Props = Omit<
  RemoveEmployeeSkillDialogProps,
  'onSkillRemoved' | 'show' | 'inProgress' | 'skillIdToRemove'
> & {
  projectId: string;
  skillIdToRemove: string | null;
};

export const RemoveProjectSkillDialogConnected: React.FC<Props> = ({
  projectId,
  skillIdToRemove,
  ...props
}) => {
  const { onClose } = props;
  const { removeProjectSkill, inProgress } = useRemoveProjectSkill();

  const handleSkillRemoved = useCallback(
    (id: string) => {
      removeProjectSkill({ id, projectId }).then((ok) => {
        if (ok) onClose();
      });
    },
    [removeProjectSkill, projectId, onClose],
  );

  if (!skillIdToRemove) {
    return null;
  }

  return (
    <RemoveEmployeeSkillDialog
      {...props}
      translationNamespace="skills.removeProjectSkill"
      show={true}
      skillIdToRemove={skillIdToRemove}
      inProgress={inProgress}
      onSkillRemoved={handleSkillRemoved}
    />
  );
};
